import { createSlice } from "@reduxjs/toolkit";
import Axios from "../../utils/axiosInstance";

const initialState = {
  quotationList: [],
  forwardSuggestedProfit: null,
  backwardSuggestedProfit: null,
};

const slice = createSlice({
  name: "quotation",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.quotationList = [];
    },

    // CREATE quotation
    createQuotation(state, action) {
      state.isLoading = false;
      state.items = action.payload;
    },

    // GET
    getQuotationListSuccess(state, action) {
      state.isLoading = false;
      state.quotationList = action.payload;
    },

    getForwardSuggestedProfitSuccess(state, action) {
      state.isLoading = false;
      state.forwardSuggestedProfit = action.payload;
    },

    getBackwardSuggestedProfitSuccess(state, action) {
      state.isLoading = false;
      state.backwardSuggestedProfit = action.payload;
    },

    deleteQuotationItem(state, action) {
      const quotationItems = state.masterCost.filter(
        (items) => items.id !== action.payload,
      );
      state.items = quotationItems;
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getQuotationList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.get("/quotation-items");

      dispatch(slice.actions.getQuotationListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function dispatchNewQuotation(quotation) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.post("/quotation-items", quotation);
      dispatch(slice.actions.createQuotation(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function dispatchUpdateQuotation(item) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.put(`/quotation-items/${item.id}`, item);
      return dispatch(slice.actions.createQuotation(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function dispatchDeleteQuotationItem(itemId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await Axios.delete(`/quotation-items/${itemId}`);
      dispatch(slice.actions.deleteQuotationItem(itemId));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getForwardSuggestedProfit(total) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.get(`/profit-slabs/forward?total=${total}`);

      dispatch(slice.actions.getForwardSuggestedProfitSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getBackwardSuggestedProfit(total) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.get(`/profit-slabs/backward?total=${total}`);

      dispatch(slice.actions.getBackwardSuggestedProfitSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
